import React from "react";
import { motion } from "framer-motion";
import "./about.css";
import jyothish from "../../Images/jyothish.jpg";
import candle from "../../Images/candke.png";
import institution from "../../Images/Institutions.jpg";
import objectives from "../../Images/Objectives.jpg";
import mission from "../../Images/vision.jpg";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1 className="about-us-heading">ABOUT US</h1>

      <motion.section
        className="about-section"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src={candle} alt="Deepti Foundation" className="about-images" />
        <div className="text-content">
          <h2 className="about-usheading">
            Deepti Educational and Charitable Foundation
          </h2>
          <p className="about-us-description" style={{ textAlign: 'left' }}>
            Deepti Educational and Charitable Foundation is a registered
            non-profit organization (Reg. No. 27/2012). The Foundation is
            recognized under Section 12AA and 80G of the Income Tax Act
            (Registration No. AACTD1381KE20213), enabling donors to claim tax
            exemptions on their contributions. We are also registered under the
            Foreign Contribution (Regulation) Act (FCRA No. 052930255), which
            allows us to receive international funding approved by the Union
            Ministry of Home Affairs. In addition, Deepti holds Corporate Social
            Responsibility (CSR) Registration (CSR No. CSR00073791), qualifying
            us to receive CSR contributions.
          </p>
        </div>
      </motion.section>

      <motion.section
        className="about-section reverse"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src={jyothish} alt="Our History" className="about-image" />
        <div className="text-content">
          <h2 className="about-usheading">Our Story</h2>
          <p className="about-us-description" style={{ textAlign: 'left' }}>
            Jyothish, a son with special needs, born to Dr. Mathew C. Vargheese
            and Dr. Susan Mathew is the inspiration behind the founding of
            Deepti. The challenges and hardships they faced in raising Jyothish
            prompted them to reach out to other children with similar conditions
            and their parents. What began as a therapy centre for children with
            Cerebral Palsy on August 10, 2009, has since expanded to support
            children with a range of special needs, including Cerebral Palsy,
            Downs Syndrome, Autism, ADHD, Visual impairments, Intellectual
            disabilities and Learning disabilities. Deepti is committed to the
            basic right of every child to receive the education and care they
            deserve.
          </p>
        </div>
      </motion.section>

      <motion.section
        className="about-section"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src={objectives} alt="Main Objectives" className="about-image" />
        <div className="text-content">
          <h2 className="about-usheading">Main Objectives</h2>
          <p className="about-us-description" style={{ textAlign: 'left' }}>
            The main objective of Deepti Educational and Charitable Foundation
            is to help differently-abled children and young adults by providing
            the best available facilities for rehabilitation, catering to their
            special needs, and training them appropriately to facilitate their
            integration into mainstream society. Deepti provides special
            educational and allied health services to children with Cerebral
            Palsy, Autism, Downs Syndrome, Intellectual and Learning
            Disabilities. We extend guidance and counseling to parents and
            develop self-help units for them. We also aim to empower the poor
            and needy, especially women and children, through various support
            programs.
          </p>
        </div>
      </motion.section>

      <motion.section
        className="about-section reverse"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img
          src={institution}
          alt="Our Institutions"
          className="about-image-instution"
        />
        <div className="text-content">
          <h2 className="about-usheading">Our Institutions</h2>
          <p className="about-us-description">
            Under the trust, we operate several specialized institutions:
          </p>
          <ul className="institutions-list" style={{ textAlign: 'left' }}>
            <li>
              <strong>Deepti Special School and Rehabilitation Centre:</strong>{" "}
              Addresses educational and rehabilitational needs of children with
              special needs (3-18 years). Registered with the Departments of
              Education and Social Justice, Kerala State.
            </li>
            <li>
              <strong>Deepti Vocational Training Centre:</strong> Provides
              various vocational training programs for young adults with special
              needs above 18 years.
            </li>
            <li>
              <strong>Deepti Child Development Centre:</strong> Helps diagnose,
              assess, and intervene in child developmental issues for children
              aged 0-6 years.
            </li>
            <li>
              <strong>Little Flower Montessori and Pre-School:</strong> Supports
              inclusive education through play-based and activity-oriented
              learning for children aged 2-6 years.
            </li>
            <li>
              <strong>Ignite Counselling & Guidance Centre:</strong> Offers
              counseling and guidance for various personal issues, along with
              skill development training and career guidance.
            </li>
          </ul>
        </div>
      </motion.section>

      <motion.section
        className="about-section"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img
          src={mission}
          alt="Our Mission and Vision"
          className="about-image"
        />
        <div className="text-content">
          <h2 className="about-usheading">Our Vision</h2>
          <p className="about-us-description">
            To become a 'Centre of Excellence', providing comprehensive
            rehabilitation measures, education, and support, while enriching the
            lives of individuals with various challenges.
          </p>
          <h2 className="about-usheading">Our Mission</h2>
          <p className="about-us-description">
            Deepti is committed to being the most preferred special education
            centre through professional excellence, child-centricity, and
            passionate service.
          </p>
          <h2 className="about-usheading">Our Motto</h2>
          <p className="about-us-description">
            "Enabling the Present - Enlightening the Future"
          </p>
        </div>
      </motion.section>

      <motion.section
        className="about-section reverse"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="text-content">
          <h2 className="about-usheading">Board of Directors</h2>
          <ul className="directors-list" style={{ textAlign: 'left' }}>
            <li>
              <strong>Dr. Susan Mathew:</strong> Managing Trustee
            </li>
            <li>
              <strong>Dr. Mathew C. Vargheese:</strong> Founder Trustee
            </li>
            <li>
              <strong>Rev. Samuel Mathew:</strong> Treasurer
            </li>
            <li>
              <strong>Dr. George Varghese:</strong> Trustee
            </li>
            <li>
              <strong>Mr. George Baby:</strong> Trustee
            </li>
          </ul>
        </div>
      </motion.section>
    </div>
  );
};

export default AboutUs;
